const points = {
    // origin: 'https://proxy.amateum.com/',
    // test: 'https://api.rfsgr.ru/',
    test: 'https://api-students.amateum.com/',
    preprod: 'https://preprod-api-students.rfs.ru/',
    prod: 'https://api-students.rfs.ru/'
}

const domains = {
    test: 'https://students.amateum.com/',
    preprod: 'https://preprod-students.rfs.ru/',
    prod: 'https://students.rfs.ru/'
}

const fantasy = {
    test: 'https://preprod-fantasy-api.rfs.ru/',
    preprod: 'https://preprod-fantasy-api.rfs.ru/',
    prod: 'https://fantasy-api.rfs.ru/'
}

// export const ENDPOINT = points[process.env.INSTANCE] || 'https://api.rfsgr.ru/'
export const ENDPOINT = points[process.env.INSTANCE] || points.test
export const PUBLICENDPOINT = process.env.NODE_ENV === 'production' ? domains[process.env.INSTANCE] : 'http://localhost:5173/'
export const FANTASY = fantasy[process.env.INSTANCE] || 'https://preprod-fantasy-api.rfs.ru/'
// export const ENDPOINT = process.env.NODE_ENV === 'production' ? points[process.env.INSTANCE] : 'http://localhost:3123/';

export const TIP_FLOWS = {
    federation: ['structure'],
    club: []
}

export const SITE_KEY = "6Lc4vR8qAAAAABmXZzh5PHZSBEvtYf3NNVJG_5JI"
